module.exports = __webpack_public_path__ + "media/banner2.e260a4b7.mp4";